import React, { useEffect, useState } from "react";
import Field from "./Field";
import DevelopmentTree from "./developmentTree";
import { Cancel, Done, Exit } from "./Icons";
import { updateData } from "../functions/firebaseFunctions";

export default function GoalForm({ goals, projectId, index, setIndex, setGoals }) {

    // for the three following variables undefined means they were never updated
    const [name, setName] = useState(undefined);
    const [desc, setDesc] = useState(undefined);
    const [completion, setCompletion] = useState(undefined);
    const [deleteConfirm, setDeleteConfirm] = useState(false);

    const [isChanged, setIsChanged] = useState(false);

    const buttonStyle = {
        backgroundColor: 'transparent',
        margin: 5,
        borderColor: 'black',
        borderStyle: 'solid',
        borderWidth: 1,
        color: 'black',
        display: 'flex',
        width: 'auto',
        gap: 5,
        height: 40,
        alignItems: 'center',
    }
    const ClearStates = () => {
        if (!goals || goals.length === index) { // if the goal is new only revert to previous index
            setIndex(index - 1)
        } else { // otherwise chnage values
            setName(goals[index].name);
            setDesc(goals[index].desc);
            setCompletion(goals[index].completion);

        }
        setIsChanged(false); // hide buttons
    }
    const adress = 'projects/' + projectId + '/goals';
    const UpdateGoal = event => {
        event.preventDefault();
        const newGoal = {
            name: name,
            desc: desc,
            completion: completion
        }
        // get adress and update the data for the goals
        const goalsCopy = goals || [];//Copy all the goals
        const indexCopy = index < 0 ? 0 : index // in case of a new goal the index can not be set lower than 0
        goalsCopy[indexCopy] = newGoal;//And replace the only one that has changed
        //console.log('new goals', goalsCopy);
        updateData(adress, goalsCopy);//Upload updated goal array
        setGoals(goalsCopy);// update the local copy
        setIsChanged(false);// hide the buttons
        const newIndex = index + 1; // decrement index
        setIndex(newIndex); // update index
    }
    const deleteGoal = () => {
        const newGoals = goals.filter((_, i) => i !== index);
        setGoals(newGoals); // update the local copy
        const newIndex = index - 1; // decrement index
        updateData(adress, newGoals);//Upload updated goal array
        setIsChanged(false); // hide buttons
        setIndex(newIndex); // update index
    }

    useEffect(() => {
        setDeleteConfirm(false)// when changing goals change confirm button back to delete
        // if ther is a change index or goals
        if (!goals || goals.length === index) {
            // if there is no goals or the index is equal to the lenght of the goals
            // that means that the currently displayed goal is a new goal
            // (index starts with 0 therefore when lenght is 2 the highes index could be 1
            // and if current index is more than the last existing goal the user is trying to 
            // create a new goal)
            // Set the field values to the follwoing
            setName("Enter Title")
            setDesc("Enter Description")
            setCompletion(0)
        } else {
            // in other cases the user has open an existing goal
            // Set the field values to the existing info from the database
            setName(goals[index].name || undefined)
            setDesc(goals[index].desc || undefined)
            setCompletion(goals[index].completion || undefined) // if the goal's completion level is not set yet we set it to -1
        }
    }, [index, goals])

    useEffect(() => {
        setDeleteConfirm(false)// when changing information change confirm button back to delete
        //console.log("name, desc, or completion has changed")
        // if ther is a change index or goals
        if (!goals || goals.length === index) {
            // if there is no goals or the index is equal to the lenght of the goals
            // that means that the currently displayed goal is a new goal
            // (index starts with 0 therefore when lenght is 2 the highes index could be 1
            // and if current index is more than the last existing goal the user is trying to 
            // create a new goal)
            // if the values are not equall to the inital values
            //console.log("new goal")
            if (
                name !== "Enter Ttitle" ||
                desc !== "Enter Description" ||
                completion !== 0
            ) {
                //console.log("is changed")
                setIsChanged(true);
            }
        } else {
            // in other cases the user has open an existing goal
            // if the values are not equall to the inital values from the database
            //console.log("old goal")
            if (
                (name && desc) && // if values are defined
                (// and not equal to the ones in the database
                    name !== goals[index].name ||
                    desc !== goals[index].desc ||
                    completion !== goals[index].completion
                )
            ) {
                //console.log("is changed")
                setIsChanged(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, desc, completion])
    return (
        <form className='GridTwoOut'
            onSubmit={UpdateGoal}>
            <div style={{ width: '100%' }} >
                <Field type="h3" value={name} color="black" updateValue={setName} inForm />
                <Field type="p" value={desc} color="black" updateValue={setDesc} inForm />
            </div>
            {goals && <DevelopmentTree index={index} goals={goals} completion={completion} editable updateCompletion={setCompletion} />}
            <div style={{
                display: "flex",
                gap: 5,
                gridColumn: '1 / -1'
            }}>
                {isChanged && <button type="submit"
                    className='popUp btn'
                    style={buttonStyle}>
                    Save
                    <Done color='black' size={20} />
                </button>}
                {isChanged && <button type="button"
                    className='popUp btn'
                    onClick={ClearStates}
                    style={buttonStyle}>
                    Cancel
                    <Cancel color='black' size={20} />
                </button>}
                {(goals && goals.length !== index) && <button type="button"
                    className='popUp btn'
                    onClick={() => {
                        if (deleteConfirm) {
                            setDeleteConfirm(false)
                            deleteGoal()
                            // if confirm was pressed the button will delete this goal
                        } else {
                            setDeleteConfirm(true) // if the button is pressed for the first time
                            // the button will change to confirm
                        }
                    }}
                    style={{
                        backgroundColor: 'transparent',
                        margin: 5,
                        borderColor: 'var(--red)',
                        borderStyle: 'solid',
                        borderWidth: 1,
                        color: 'var(--red)',
                        display: 'flex',
                        width: 'auto',
                        gap: 5,
                        height: 40,
                        alignItems: 'center',
                    }}>
                    {deleteConfirm ? "Confirm" : "Delete"}
                    <Exit color='var(--red)' size={20} />
                </button>}
            </div>
        </form>
    )
}